<template>
  <JobProfileSettingsSection
    id="profile-fields"
    title="Profile Fields"
  >
    <template #description>
      Control which fields appear on job profiles and set whether they are required. <br>
      You can drag to reorder how they appear in the editor.
      <a
        href="#"
        data-beacon-article-sidebar="69cd28049207e139315c3eb2"
        @click.stop
      >Learn more about profile fields</a>.
    </template>

    <div class="column-header d-flex align-center ga-6 w-100 mb-2">
      <span class="column-header-label field-col-field">Field</span>
      <span class="column-header-label field-col-visibility">Visibility</span>
      <span class="column-header-label field-col-status">Status</span>
    </div>

    <draggable
      v-model="fields"
      item-key="ulid"
      handle=".drag-handle"
      tag="div"
      class="draggable-list d-flex flex-column ga-2 w-100"
      ghost-class="ghost"
      :disabled="componentLoading"
      @end="syncSortOrders"
    >
      <template #item="{ element }">
        <JobProfileFieldRow
          :field="element"
          :disabled="componentLoading"
          @update:visible="setFieldVisible(element.ulid, $event)"
          @update:required="setFieldRequired(element.ulid, $event)"
        />
      </template>
    </draggable>
  </JobProfileSettingsSection>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import draggable from 'vuedraggable';
import JobProfileFieldRow from '@/components/settings/components/JobProfileFieldRow.vue';
import JobProfileSettingsSection from '@/components/settings/components/JobProfileSettingsSection.vue';
import { useAppLoading } from '@/stores/app/loading';
import { useJobProfileSettings } from '@/stores/settings/jobProfileSettings';

const jobProfileSettings = useJobProfileSettings();
const { fields } = storeToRefs(jobProfileSettings);
const { syncSortOrders, setFieldVisible, setFieldRequired } = jobProfileSettings;

const { componentLoading } = storeToRefs(useAppLoading());
</script>

<style scoped lang="less">
.column-header-label {
  font-size: 13px;
  font-weight: 600;
  line-height: 1.5;
  color: @text-dark;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}

.field-col-field {
  flex: 0 0 300px;
  width: 300px;
}

.field-col-visibility {
  flex: 0 0 100px;
  width: 100px;
}

.field-col-status {
  flex: 1 1 auto;
  min-width: 0;
}

:deep(.ghost) {
  opacity: 0.55;
}
</style>
